import { render, staticRenderFns } from "./ModalUpdateAlias.vue?vue&type=template&id=574251d6&scoped=true&"
import script from "./ModalUpdateAlias.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574251d6",
  null
  
)

export default component.exports